import { motion } from "framer-motion";
import { STATS } from "@/data";

const ABOUT_IMG = "https://images.unsplash.com/photo-1541888946425-d81bb19240f5";

export default function About() {
  return (
    <section id="about" className="relative py-28 md:py-36 bg-secondary/30 border-y border-white/10" data-testid="about">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="overflow-hidden rounded-2xl clip-frame">
            <img src={ABOUT_IMG} alt="Construction site from above" className="h-[440px] w-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-4 md:right-6 rounded-2xl bg-primary text-primary-foreground px-7 py-5 shadow-2xl">
            <div className="font-heading text-3xl font-bold">Since day one</div>
            <div className="text-xs font-semibold opacity-80">Independent &amp; standards-driven</div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7"
        >
          <span className="text-primary text-sm font-semibold tracking-[0.25em] uppercase">About us</span>
          <h2 className="mt-4 font-heading font-light tracking-tighter text-4xl sm:text-5xl leading-[1.05] text-foreground">
            Quality is not an inspection.<br />It is a discipline.
          </h2>
          <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">
            Qonnect QA is a construction quality inspection consultancy for builders and developers who
            refuse to gamble on quality. We embed QA/QC systems, author SOPs and methodologies, inspect
            materials, coordinate with accredited NABL labs and translate Indian and international standards
            into decisions your site teams can actually execute.
          </p>
          <p className="mt-4 text-base text-muted-foreground leading-relaxed max-w-2xl">
            The result is measurable: fewer defects, less rework, and a documented trail of quality you can
            stand behind — true to our promise, <span className="text-foreground font-medium">engineering trust, delivering quality.</span>
          </p>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-8">
            {STATS.map((st, i) => (
              <motion.div
                key={st.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`stat-${i}`}
              >
                <div className="font-heading text-4xl md:text-5xl font-bold text-primary tracking-tight">{st.value}</div>
                <div className="mt-2 text-xs md:text-sm text-muted-foreground">{st.label}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
